import React from "react";
import JustTalkHero from "./JustTalkHero";
import WhyChooseJusttawk from "./WhyChooseJusttawk";
import ToolsFeatureSection from "./ToolsFeatureSection";
import TrustedBySlider from "./TrustedBySlider";
import CertificationSection from "./CertificationSection";
import HeroBanner from "./HeroBanner";

const LandingPage = () => {
  return (
    <>
      <JustTalkHero />
      <WhyChooseJusttawk />
      <ToolsFeatureSection />
      <TrustedBySlider />
      <CertificationSection />
      <HeroBanner />
    </>
  );
};

export default LandingPage;
